import { render } from "./RatingPropsCmp.vue?vue&type=template&id=46e78611"
import script from "./RatingPropsCmp.vue?vue&type=script&lang=js"
export * from "./RatingPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__